import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Zap, Target, Briefcase, ArrowRight } from 'lucide-react';
import PageLayout, { PageHero } from '../components/PageLayout';

const VALUES = [
  { icon: Zap,    accent: 'accent-3', title: 'Move fast',        desc: 'We ship daily. No three-month roadmap ceremonies — we talk to users on Monday and deploy on Friday.' },
  { icon: Target, accent: 'accent-1', title: 'Customer obsessed', desc: 'Every feature we build solves a real problem a real BPO or sales team told us about.' },
  { icon: Users,  accent: 'accent-4', title: 'Small and proud',   desc: 'We are a tiny founding team. Everyone owns their area end to end — no hand-offs, no bureaucracy.' },
];

const Careers = () => (
  <PageLayout
    title="Careers — Join the WASLX Team"
    description="Help build the future of mobile call center technology. Join WASLX — a fast-moving team obsessed with building tools real outbound teams love. See open roles."
    path="/careers"
  >
    <PageHero
      eyebrow="Careers"
      accent="accent-3"
      title={
        <>
          Build the future of <span className="display-accent">calling operations</span>
        </>
      }
      sub="We are a small founding team replacing expensive call center infrastructure with an Android app. If that sounds like the kind of problem you want to work on, let’s talk."
    />

    <section className="section section--muted">
      <div className="container-page">
        <div className="section-head">
          <h2 className="section-title">How we work</h2>
        </div>

        <div className="stagger-children mx-auto grid max-w-4xl gap-5 md:grid-cols-3">
          {VALUES.map(value => {
            const Icon = value.icon;
            return (
              <div
                key={value.title}
                className={`${value.accent} card card--tint card--hover animate-fade-up`}
              >
                <span className="gradient-tile">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="card-title mt-5">{value.title}</h3>
                <p className="card-body">{value.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>

    <section className="section section--surface">
      <div className="container-page">
        <div className="section-head">
          <h2 className="section-title">Open roles</h2>
          <p className="section-sub">
            We are early — no open listings right now, but we are always interested in exceptional
            people.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <div className="accent-1 empty-state">
            <span className="shape shape--arc shape--md shape--bl shape--rot-20" aria-hidden="true" />
            <span className="icon-tile icon-tile--lg">
              <Briefcase className="h-6 w-6" />
            </span>
            <h2 className="empty-state__title">No open positions right now</h2>
            <p className="empty-state__sub">
              We are focused on the beta and will post here when we are ready to grow the team.
              Interested in Android engineering, backend systems or sales ops? Drop us a note — we
              read every message.
            </p>
            <Link to="/contact" className="btn-pill btn-pill--primary mt-2">
              Send us a message
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Careers;
